import { render, staticRenderFns } from "./allowCreate-editor.vue?vue&type=template&id=7ea31b71&scoped=true&"
import script from "./allowCreate-editor.vue?vue&type=script&lang=js&"
export * from "./allowCreate-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea31b71",
  null
  
)

export default component.exports